<template>
    <div class="box">
        <div class="operation">
            <el-form ref="form" :model="form" label-width="80px" class="form" :inline="true">
                <el-form-item label="订单号" label-position="right" class="mt">
                    <el-input v-model="form.orderNo" size="small" placeholder="请输入订单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="设备sn号" label-position="right" class="mt">
                    <el-input v-model="form.deviceSn" size="small" placeholder="请输入设备sn号" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机号码" label-position="right" class="mt">
                    <el-input v-model="form.mobile" size="small" placeholder="请输入手机号码" clearable></el-input>
                </el-form-item>
                <el-form-item label="订单时间" label-position="right" class="mt">
                    <el-date-picker v-model="orderTime" type="daterange" range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange" />
                </el-form-item>
            </el-form>
            <div class="mt">
                <el-button type="primary" class="btn" @click="queryFunc" icon="el-icon-search">查询</el-button>
                <el-button class="btn" @click="clearFunc" icon="el-icon-delete">重置</el-button>
                <el-button class="btn" icon="el-icon-download" @click="onExport">导出</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: 20px;">
          <el-tab-pane label="全部订单" name="1"></el-tab-pane>
          <el-tab-pane :label="'待付款'" name="2"></el-tab-pane>
          <el-tab-pane label="已付款" name="3"></el-tab-pane>
        </el-tabs>
        <div class="tabBox">
            <el-table v-loading="loading" ref="selections" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange"
                style="width: 100%" border element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }">
                <!-- <el-table-column type="selection" width="55" /> -->
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="demo-table-expand">
                            <el-form-item label="套餐名称">{{ props.row.packageData.packageName }}</el-form-item>
                            <el-form-item label="套餐说明">{{ props.row.packageData.description }}</el-form-item>
                            <el-form-item label="售价">{{ props.row.packageData.price }}</el-form-item>
                            <el-form-item label="原价">{{ props.row.packageData.originalPrice }}</el-form-item>
                            <el-form-item label="流量">{{ props.row.packageData.flow }}</el-form-item>
                            <el-form-item label="套餐类型">
                                <span v-if="props.row.packageData.packageType === 0">优享</span>
                                <span v-if="props.row.packageData.packageType === 1">畅享</span>
                                <span v-if="props.row.packageData.packageType === 2">尊享</span>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNo" label="订单编号" />
                <el-table-column prop="mobile" label="用户手机号" />
                <!-- <el-table-column prop="deviceId" label="设备ID" /> -->
                <el-table-column prop="deviceSn" label="设备序列号" />
                <el-table-column prop="payType" label="支付类型">
                  <template slot-scope="scope">
                        {{ scope.row.payType === 10 ? '余额支付' : scope.row.payType === 20?'微信支付':scope.row.payType === 30?'支付宝支付':scope.row.payType === 40?'线下支付':scope.row.payType === 50?'积分兑换':'' }}
                    </template>
                </el-table-column>
                <el-table-column prop="payStatus" label="支付状态">
                    <template slot-scope="scope">
                        {{ scope.row.payStatus === 10 ? '待支付' : '已支付' }}
                    </template>
                </el-table-column>
                <el-table-column prop="orderTime" label="下单时间" />
                <el-table-column prop="paymentTime" label="支付时间" />
                <el-table-column prop="orderAmount" label="订单金额" />
                <el-table-column prop="actualPaymentAmount" label="实际支付金额" />
                <el-table-column prop="remark" label="备注" />
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="paginationBox">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper"
                :total="total" class="pagination">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import WifiApi from '@/api/wifi.js'
import {getCookie} from '@/utils/base.js';
import qs from "qs";
export default {
    data() {
        return {
            orderTime: [],
            activeName: '1',
            form: {
                orderNo: '',
                payStatus: null,
                deviceSn: '',
                mobile: '',
                orderStartTime: '',
                orderEndTime: '',
            },
            tableData: [],
            loading: true,
            dialogFormVisible: false,
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            selections: []
        }
    },
    methods: {
        timeChange() {
            this.form.orderStartTime = this.orderTime[0]
            this.form.orderEndTime = this.orderTime[1]
        },
        toggleSelection() {
            this.$refs.selections.clearSelection();
        },
        getDialogFormVisible(flag) {
            this.dialogFormVisible = flag
        },
        handleSelectionChange(val) {
            this.selections = val;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getList();
        },
        handleClick() {
            this.form.payStatus = this.activeName === '2' ? 10 : this.activeName === '3' ? 20 : null
            this.getList();
        },
        // 渲染列表
        getList() {
            this.loading = true;
            const params = {
                orderNo: this.form.orderNo,
                payStatus: this.form.payStatus,
                deviceSn: this.form.deviceSn,
                mobile: this.form.mobile,
                orderStartTime: this.form.orderStartTime,
                orderEndTime: this.form.orderEndTime,
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
            }
            if(this.form.payStatus) params.payStatus = this.form.payStatus
            WifiApi.orderList({ ...params }).then(res => {
                if(res.data.records) {
                    res.data.records.forEach(item => {
                        if(item.packageDataJson) {
                            item.packageData = JSON.parse(item.packageDataJson)
                        }
                    })
                    this.tableData = res.data.records
                }
                this.total = res.data.total
                this.loading = false;
            }).catch(e => {
                this.loading = false;
            })
        },
        // 查询按钮
        queryFunc() {
            this.pageIndex = 1
            this.getList();
        },
        onExport: function() {
            let self = this;
            const Params = {
                orderNo: this.form.orderNo,
                payStatus: this.form.payStatus,
                deviceSn: this.form.deviceSn,
                mobile: this.form.mobile,
                orderStartTime: this.form.orderStartTime,
                orderEndTime: this.form.orderEndTime,
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
            }
            Params.token = getCookie('token');
            let baseUrl = window.location.protocol + '//' + window.location.host;
            window.location.href = baseUrl + '/api/shop/iot/order/export?' + qs.stringify(Params);
        },
        clearFunc() {
            this.pageIndex = 1
            this.form.orderNo = ''
            this.form.payStatus = null
            this.form.deviceSn = ''
            this.form.mobile = ''
            this.form.orderStartTime = ''
            this.form.orderEndTime = ''
            this.orderTime = []
            this.getList();
        }
    },
    mounted() {
        this.getList();
    }
}
</script>

<style scoped>
.mt {
    margin-top: 20px
}

.tabBox {
    margin: 10px 0;
}

.box {
    padding: 10px;
}

.demo-table-expand {
    font-size: 0;
    padding-left: 50px;
}
.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}
.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}

.form {
    margin-right: 20px;
}

.btn {
    margin-left: 15px;
    display: inline-block
}

.el-form-item {
    margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ybwifi/order/index.vue